
import gql from 'graphql-tag';
import ErrorHandler from '@/services/ErrorHandler';
import { apolloClient } from '@/apollo';
import moment from 'moment';

const DefaultValuesStore = {
  namespaced: true,
  state: {
    dailyLunchStartDay: undefined,
    dailyLunchStartHour: undefined,
    fridayLunchStartDay: undefined,
    fridayLunchStartHour: undefined,
    intervalTypes: [
      { value: 'FULL_MONTH', label: 'monthlyExpensesContainer.intervalTypeFullMonth' },
      { value: 'FIRST_HALF', label: 'monthlyExpensesContainer.intervalTypeFirstHalf' },
      { value: 'SECOND_HALF', label: 'monthlyExpensesContainer.intervalTypeSecondHalf' },
    ],
  },
  actions: {
    async updateDefaults({ commit }, {
      dailyLunchStartDay,
      dailyLunchStartHour,
      fridayLunchStartDay,
      fridayLunchStartHour,
    }) {
      try {
        const response = await apolloClient.mutate({
          mutation: gql`
            mutation DefaultValuesMutation($values: DefaultValuesInput!) {
              updateDefaultValues(values: $values) {
                dailyLunchStartDay
                dailyLunchStartHour
                fridayLunchStartDay
                fridayLunchStartHour
              }
            }
          `,
          variables: {
            values: {
              dailyLunchStartDay,
              dailyLunchStartHour: `${+dailyLunchStartHour - (moment().utcOffset() / 60)}`,
              fridayLunchStartDay,
              fridayLunchStartHour: `${+fridayLunchStartHour - (moment().utcOffset() / 60)}`,
            },
          },
        });
        commit('saveDefaults', response.data.updateDefaultValues);
      } catch (error) {
        ErrorHandler.handleApolloError(error);
      }
    },
    async loadDefaultValues({ commit }) {
      try {
        const response = await apolloClient.query({
          query: gql`query DefaultValuesQuery {
            defaultValues {
              dailyLunchStartDay
              dailyLunchStartHour
              fridayLunchStartDay
              fridayLunchStartHour
            }
          }`,
          fetchPolicy: 'network-only',
        });
        commit('saveDefaults', response.data.defaultValues);
      } catch (error) {
        ErrorHandler.handleApolloError(error);
      }
    },
  },
  mutations: {
    saveDefaults(state, {
      dailyLunchStartDay,
      dailyLunchStartHour,
      fridayLunchStartDay,
      fridayLunchStartHour,
    }) {
      state.dailyLunchStartDay = dailyLunchStartDay;
      state.dailyLunchStartHour = +dailyLunchStartHour + (moment().utcOffset() / 60);
      state.fridayLunchStartDay = fridayLunchStartDay;
      state.fridayLunchStartHour = +fridayLunchStartHour + (moment().utcOffset() / 60);
    },
  },
};

export default DefaultValuesStore;
